import React from "react";

export const downloadSquareOutline = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <path
        fill="currentColor"
        d="M12 6.25a.75.75 0 0 1 .75.75v5.19l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72V7a.75.75 0 0 1 .75-.75M7.25 17a.75.75 0 0 1 .75-.75h8a.75.75 0 1 1 0 1.5H8a.75.75 0 0 1-.75-.75"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.95 2.5c-2.04 0-3.64 0-4.887.168-1.276.171-2.284.53-3.075 1.32-.79.791-1.149 1.799-1.32 3.076C2.5 8.31 2.5 9.909 2.5 11.95v.1c0 2.04 0 3.64.168 4.887.171 1.276.53 2.284 1.32 3.075.791.79 1.799 1.149 3.076 1.32 1.246.168 2.845.168 4.886.168h.1c2.04 0 3.64 0 4.887-.168 1.276-.171 2.284-.53 3.075-1.32.79-.791 1.149-1.799 1.32-3.076.168-1.246.168-2.845.168-4.886v-.1c0-2.04 0-3.64-.168-4.887-.171-1.276-.53-2.284-1.32-3.075-.791-.79-1.799-1.149-3.076-1.32C15.69 2.5 14.091 2.5 12.05 2.5zM4.926 4.926c.504-.504 1.184-.793 2.314-.945C8.39 3.827 9.9 3.826 12 3.826s3.61.001 4.76.155c1.13.152 1.811.442 2.315.945.503.504.792 1.184.944 2.314.154 1.15.155 2.659.155 4.76s-.001 3.61-.155 4.76c-.152 1.13-.442 1.811-.945 2.315-.504.503-1.184.792-2.314.944-1.15.154-2.659.155-4.76.155s-3.61-.001-4.76-.155c-1.13-.152-1.811-.442-2.315-.945-.503-.504-.792-1.184-.944-2.314-.154-1.15-.155-2.659-.155-4.76s.001-3.61.155-4.76c.152-1.13.442-1.81.945-2.314"
        clipRule="evenodd"
      />
    </svg>
  );
};
